const { appApiUrl } = require('./api-url');

const mcpServerUrl = 'https://spache.online/mcp';

async function mcpRequest (user, path, options = {}) {
  const token = await user.getIdToken();
  const response = await fetch(`${appApiUrl}${path}`, {
    ...options,
    headers: {
      authorization: `Bearer ${token}`,
      ...(options.body ? { 'content-type': 'application/json' } : {}),
      ...(options.headers || {})
    }
  });
  const result = await response.json();
  if (!response.ok) throw new Error(result.error || 'Unable to manage MCP access');
  return result;
}

function loadMcpOAuthRequest (requestId) {
  return fetch(`${appApiUrl}/api/mcp/oauth/request`, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ requestId })
  }).then(async response => {
    const result = await response.json();
    if (!response.ok) throw new Error(result.error || 'This authorization request is no longer valid');
    return result;
  });
}

function completeMcpOAuthConsent (user, requestId, approved) {
  return mcpRequest(user, '/api/mcp/oauth/consent', {
    method: 'POST',
    body: JSON.stringify({ requestId, approved })
  });
}

function denyMcpOAuthConsent (requestId) {
  return fetch(`${appApiUrl}/api/mcp/oauth/consent`, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ requestId, approved: false })
  }).then(async response => {
    const result = await response.json();
    if (!response.ok) throw new Error(result.error || 'Unable to cancel this authorization request');
    return result;
  });
}

function loadMcpConnections (user) {
  return mcpRequest(user, '/api/account/mcp-connections');
}

function revokeMcpConnection (user, grantId) {
  return mcpRequest(user, `/api/account/mcp-connections/${encodeURIComponent(grantId)}`, {
    method: 'DELETE'
  });
}

module.exports = {
  completeMcpOAuthConsent,
  denyMcpOAuthConsent,
  loadMcpConnections,
  loadMcpOAuthRequest,
  mcpServerUrl,
  revokeMcpConnection
};
